import { KeyValueObject } from "@components/common/types/general";
import { getColorVariable } from "@components/common/utils/helper";
import { type AlertProps } from "./alert";

export function getBackgroundColor(color: AlertProps["color"], colorizeOnlyIcon: AlertProps["colorizeOnlyIcon"], theme: any): KeyValueObject {
    if (colorizeOnlyIcon) {
        return {
            backgroundColor: theme.colors.white,
        };
    }
    return {
        backgroundColor: getColorVariable(color, theme, {
            white: theme.colors.white,
            colorize: theme.colors[color || "primary"][100],
            default: theme.colors.gray[950],
        }),
    };
}

export function getColor(color: AlertProps["color"], colorizeOnlyIcon: AlertProps["colorizeOnlyIcon"], theme: any): KeyValueObject {
    if (colorizeOnlyIcon) {
        return { color: theme.colors.gray[950] };
    }
    return {
        color: getColorVariable(color, theme, {
            white: theme.colors.gray[950],
            colorize: theme.colors[color || "primary"][800],
            default: theme.colors.white,
        }),
    };
}

export function getBorderColor(color: AlertProps["color"], colorizeOnlyIcon: AlertProps["colorizeOnlyIcon"], theme: any): KeyValueObject {
    if (colorizeOnlyIcon) {
        return { borderColor: theme.colors.white };
    }
    return {
        borderColor: getColorVariable(color, theme, {
            white: theme.colors.gray[100],
            colorize: theme.colors[color || "primary"][200],
            default: theme.colors.gray[950],
        }),
    };
}

export function getBorderRadius(rounded: AlertProps["rounded"], theme: any): KeyValueObject {
    if (rounded === "md") {
        return { borderRadius: theme.borderRadius.DEFAULT };
    }
    if (rounded === "lg") {
        return { borderRadius: theme.borderRadius.lg };
    }
    return { borderRadius: theme.borderRadius.none };
}

export function getIconBackgroundColor(color: AlertProps["color"], theme: any): KeyValueObject {
    return {
        backgroundColor: getColorVariable(color, theme, {
            white: theme.colors.gray[950],
            colorize: theme.colors[color || "primary"][500],
            default: theme.colors.white,
        }),
    };
}

export function getIconColor(color: AlertProps["color"], theme: any): KeyValueObject {
    return {
        color: getColorVariable(color, theme, {
            white: theme.colors.white,
            colorize: theme.colors.white,
            default: theme.colors.gray[950],
        }),
    };
}
